<div class="textContainer">

	<div class="title1 aTitle">
		<span>Datenschutzerklärung</span>
	</div>

	@if( bLoading ) {
		<mat-spinner />
	}
	@else if( bError ) {
		<div class="errorWarning">
			Beim Laden der Daten ist ein Fehler aufgetreten
		</div>
	}
	@else {
		<div [innerHTML]="legalHtml"></div>
	}

</div>